import React, { useEffect, useState, useRef, createElement } from 'react';
import { LeafIcon, DropletIcon, MoonIcon, CheckIcon, ArrowRightIcon, ShieldCheckIcon, DownloadIcon, FlaskConicalIcon, XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: unknown;
  }
}
function LegalModal({
  type,
  onClose
}: {
  type: ModalType;
  onClose: () => void;
}) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);
  const privacy = <>
      <h2 style={{
      fontFamily: 'var(--font-heading)',
      fontWeight: 500
    }} className="text-3xl mb-6" data-id="element-2">
        Política de Privacidad
      </h2>
      <div className="space-y-4 text-sm leading-relaxed" style={{
      opacity: 0.85
    }} data-id="element-3">
        <p data-id="element-4">
          <strong data-id="element-5">Última actualización:</strong> febrero 2026
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-6">
          1. Responsable del tratamiento
        </h3>
        <p data-id="element-7">
          Protocolo Reinicio Hormonal es responsable del tratamiento de los
          datos personales que nos facilites a través de esta página web.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-8">
          2. Datos que recopilamos
        </h3>
        <p data-id="element-9">
          Únicamente recopilamos los datos necesarios para procesar tu compra:
          nombre, dirección de correo electrónico y datos de pago (gestionados
          de forma segura por nuestro proveedor de pagos). No almacenamos datos
          de tarjetas de crédito.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-10">
          3. Finalidad del tratamiento
        </h3>
        <p data-id="element-11">
          Tus datos se utilizan exclusivamente para: (a) procesar y entregar tu
          pedido, (b) enviarte la confirmación de compra y el enlace de
          descarga, y (c) atender consultas relacionadas con tu compra.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-12">
          4. Conservación de datos
        </h3>
        <p data-id="element-13">
          Conservamos tus datos durante el tiempo necesario para cumplir con las
          obligaciones legales y contables aplicables, generalmente no más de 5
          años.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-14">5. Tus derechos</h3>
        <p data-id="element-15">
          Tienes derecho a acceder, rectificar, suprimir, limitar u oponerte al
          tratamiento de tus datos personales. Para ejercer estos derechos,
          puedes contactarnos por correo electrónico.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-16">6. Seguridad</h3>
        <p data-id="element-17">
          Aplicamos medidas técnicas y organizativas adecuadas para proteger tus
          datos personales contra el acceso no autorizado, la pérdida o la
          divulgación.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-18">7. Cookies</h3>
        <p data-id="element-19">
          Esta página puede utilizar cookies técnicas necesarias para su
          funcionamiento. No utilizamos cookies de seguimiento ni publicidad de
          terceros.
        </p>
      </div>
    </>;
  const terms = <>
      <h2 style={{
      fontFamily: 'var(--font-heading)',
      fontWeight: 500
    }} className="text-3xl mb-6" data-id="element-20">
        Aviso Legal y Términos de Uso
      </h2>
      <div className="space-y-4 text-sm leading-relaxed" style={{
      opacity: 0.85
    }} data-id="element-21">
        <p data-id="element-22">
          <strong data-id="element-23">Última actualización:</strong> febrero 2026
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-24">
          1. Naturaleza del producto
        </h3>
        <p data-id="element-25">
          El Protocolo Reinicio Hormonal es una guía informativa en formato
          digital (PDF). Su contenido tiene carácter educativo y divulgativo, y
          no constituye consejo médico, diagnóstico ni tratamiento de ninguna
          enfermedad o condición de salud.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-26">2. Aviso de salud</h3>
        <p data-id="element-27">
          Consulta siempre con un profesional de la salud cualificado antes de
          realizar cambios significativos en tu alimentación o estilo de vida,
          especialmente si tienes condiciones médicas preexistentes o tomas
          medicación.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-28">3. Resultados</h3>
        <p data-id="element-29">
          Los resultados descritos son orientativos y pueden variar según cada
          persona. No garantizamos resultados específicos derivados del uso de
          esta guía.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-30">
          4. Propiedad intelectual
        </h3>
        <p data-id="element-31">
          Todo el contenido de esta guía (textos, diseño, estructura) es
          propiedad exclusiva de Protocolo Reinicio Hormonal. Queda prohibida su
          reproducción, distribución o venta sin autorización expresa por
          escrito.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-32">
          5. Política de reembolso
        </h3>
        <p data-id="element-33">
          Dado que se trata de un producto digital de descarga inmediata, no se
          admiten devoluciones una vez realizada la descarga, salvo en los casos
          previstos por la legislación vigente de protección al consumidor.
        </p>
        <h3 className="font-semibold text-base mt-6 mb-2" data-id="element-34">
          6. Legislación aplicable
        </h3>
        <p data-id="element-35">
          Estos términos se rigen por la legislación española vigente. Cualquier
          controversia se someterá a los juzgados y tribunales competentes.
        </p>
      </div>
    </>;
  return <div className="fixed inset-0 z-50 flex items-end md:items-center justify-center p-0 md:p-6" style={{
    backgroundColor: 'rgba(28,28,28,0.5)',
    backdropFilter: 'blur(4px)'
  }} onClick={onClose} data-id="element-36">
      <div className="relative w-full md:max-w-2xl max-h-[85vh] overflow-y-auto rounded-t-3xl md:rounded-3xl p-8 md:p-10" style={{
      backgroundColor: 'var(--color-cream)',
      color: 'var(--color-charcoal)'
    }} onClick={e => e.stopPropagation()} data-id="element-37">
        <button onClick={onClose} className="absolute top-5 right-5 w-8 h-8 flex items-center justify-center rounded-full transition-colors" style={{
        backgroundColor: 'var(--color-cream-dark)'
      }} aria-label="Cerrar" data-id="element-38">
          <XIcon className="w-4 h-4" style={{
          color: 'var(--color-charcoal)'
        }} data-id="element-39" />
        </button>
        {type === 'privacy' ? privacy : terms}
      </div>
    </div>;
}
function useInView(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, {
      threshold
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return {
    ref,
    inView
  };
}
function FadeIn({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) {
  const {
    ref,
    inView
  } = useInView();
  return <div ref={ref} className={className} style={{
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(28px)',
    transition: `opacity 0.7s ease ${delay}ms, transform 0.7s ease ${delay}ms`
  }} data-id="element-40">
      {children}
    </div>;
}
function FaqAccordion() {
  const [open, setOpen] = useState<number | null>(null);
  const faqs = [{
    q: '¿Tengo que cocinar cosas raras?',
    a: 'En absoluto. Recetas de 15 minutos con ingredientes que compras en el súper de tu barrio.'
  }, {
    q: '¿Sirve si ya estoy en la menopausia?',
    a: 'Sí. De hecho, es cuando más necesitas equilibrar tu entorno químico para que los síntomas no te controlen a ti.'
  }, {
    q: '¿Es un libro físico?',
    a: 'Es un manual digital de acceso inmediato. Puedes leerlo en tu móvil, tablet o imprimirlo hoy mismo para empezar mañana.'
  }, {
    q: '¿Por qué es tan barato?',
    a: 'Porque quiero que el precio no sea la excusa. Quiero que entres, veas que funciona y luego me cuentes tu historia de éxito.'
  }];
  return <div className="space-y-3" data-id="element-41">
      {faqs.map((faq, i) => <FadeIn key={i} delay={i * 50} data-id="element-42">
          <div className="rounded-2xl overflow-hidden" style={{
        border: '1px solid var(--color-border)',
        backgroundColor: 'var(--color-cream)'
      }} data-id="element-43">
            <button className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left" onClick={() => setOpen(open === i ? null : i)} aria-expanded={open === i} data-id="element-44">
              <span className="text-base font-medium leading-snug" style={{
            fontFamily: 'var(--font-body)'
          }} data-id="element-45">
                {faq.q}
              </span>
              <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full" style={{
            backgroundColor: open === i ? 'var(--color-sage)' : 'rgba(143,175,138,0.15)',
            color: open === i ? '#fff' : 'var(--color-sage)',
            transition: 'background-color 0.2s ease'
          }} data-id="element-46">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{
              transform: open === i ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.25s ease'
            }} data-id="element-47">
                  <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-48" />
                </svg>
              </span>
            </button>
            <div style={{
          maxHeight: open === i ? '300px' : '0',
          overflow: 'hidden',
          transition: 'max-height 0.35s ease'
        }} data-id="element-49">
              <p className="px-5 pb-5 text-sm leading-relaxed" style={{
            opacity: 0.75
          }} data-id="element-50">
                {faq.a}
              </p>
            </div>
          </div>
        </FadeIn>)}
    </div>;
}
export function SalesPage() {
  const [modal, setModal] = useState<ModalType>(null);
  const [bonosExpanded, setBonosExpanded] = useState(false);
  useEffect(() => {
    if (typeof window === 'undefined' || window.fbq) return;
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    window.fbq = n;
    window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script') as HTMLScriptElement;
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
    window.fbq('init', '741445578526747');
    window.fbq('track', 'PageView');
  }, []);
  const handleBuyClick = () => {
    const url = 'https://tubienestarinterno.com/cart/53097347154257:1?checkout[shipping_address][country]=ES&utm_source=meta&utm_medium=paid&utm_campaign=reinicio_hormonal';
    try {
      window.fbq('track', 'AddToCart', {
        content_name: 'Protocolo Reinicio Hormonal',
        content_ids: ['53097347154257'],
        content_type: 'product',
        value: 7.0,
        currency: 'EUR'
      });
    } catch (e) {}
    setTimeout(() => {
      window.open(url, '_blank', 'noopener,noreferrer');
    }, 300);
  };
  return <main className="min-h-screen w-full" style={{
    backgroundColor: 'var(--color-cream)',
    fontFamily: 'var(--font-body)',
    color: 'var(--color-charcoal)'
  }} data-id="element-51">
      {/* Top Bar */}
      <div className="w-full py-3 text-center text-xs tracking-[0.25em] uppercase" style={{
      borderBottom: '1px solid var(--color-border)',
      opacity: 0.6
    }} data-id="element-52">
        Protocolo Reinicio Hormonal · Guía Digital
      </div>

      {/* ── HERO ── */}
      <section className="w-full px-6 py-10 md:py-16" data-id="element-53">
        <div className="max-w-4xl mx-auto text-center" data-id="element-54">
          <FadeIn data-id="element-55">
            <p className="text-xs tracking-[0.3em] uppercase mb-6" style={{
            color: 'var(--color-terracotta)'
          }} data-id="element-56">
              Para mujeres de 40+
            </p>
            <h1 className="text-5xl md:text-6xl lg:text-7xl leading-[1.1] mb-6" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500
          }} data-id="element-57">
              Tu cuerpo no está fallando.
              <br data-id="element-58" />
              <em style={{
              color: 'var(--color-sage)',
              fontStyle: 'italic'
            }} data-id="element-59">
                Está pidiendo un reset.
              </em>
            </h1>
            <p className="text-lg md:text-xl max-w-2xl mx-auto mb-12 leading-relaxed" style={{
            opacity: 0.75
          }} data-id="element-60">
              Una guía práctica de 21 días para recuperar energía, claridad
              mental y bienestar hormonal — sin fármacos ni dietas imposibles.
            </p>
          </FadeIn>
          <FadeIn delay={150} data-id="element-61">
            <div className="relative inline-block mb-12" data-id="element-62">
              <img src="https://cdn.magicpatterns.com/uploads/5mLAKnpdhDAwp3mbDu76ac/heylloyd-image-1771522687649.png" alt="Protocolo Reinicio Hormonal - Guía digital" className="mx-auto max-w-xs md:max-w-sm w-full" style={{
              filter: 'drop-shadow(0 30px 60px rgba(0,0,0,0.18))'
            }} data-id="element-63" />
            </div>
          </FadeIn>
          <FadeIn delay={250} data-id="element-64">
            <a href="#oferta" data-id="element-65">
              <button className="inline-flex items-center gap-3 px-10 py-5 text-lg font-medium text-white rounded-full mb-6" style={{
              backgroundColor: 'var(--color-terracotta)',
              boxShadow: '0 8px 30px rgba(196,149,106,0.4)',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease'
            }} onMouseEnter={e => {
              ;
              (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.04)';
              (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 12px 40px rgba(196,149,106,0.5)';
            }} onMouseLeave={e => {
              ;
              (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)';
              (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 8px 30px rgba(196,149,106,0.4)';
            }} data-id="element-66">
                Quiero mi guía por 6,39€ <ArrowRightIcon className="w-5 h-5" data-id="element-67" />
              </button>
            </a>
            <div className="flex flex-wrap justify-center gap-6 text-sm" style={{
            opacity: 0.55
          }} data-id="element-68">
              <span className="flex items-center gap-2" data-id="element-69">
                <DownloadIcon className="w-4 h-4" data-id="element-70" /> Descarga inmediata
              </span>
              <span className="flex items-center gap-2" data-id="element-71">
                <ShieldCheckIcon className="w-4 h-4" data-id="element-72" /> Pago seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-73">
                <FlaskConicalIcon className="w-4 h-4" data-id="element-74" /> Solo 6,39€
              </span>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── EMOTIONAL HOOK ── */}
      <section className="w-full px-6 py-6 md:py-10" style={{
      backgroundColor: 'var(--color-cream-dark)'
    }} data-id="element-75">
        <div className="max-w-4xl mx-auto" data-id="element-76">
          <FadeIn data-id="element-77">
            <p className="text-2xl md:text-3xl lg:text-4xl text-center italic leading-relaxed mb-8" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 400
          }} data-id="element-78">
              "Te levantas cada mañana con una batalla silenciosa..."
            </p>
          </FadeIn>
          <div className="grid md:grid-cols-3 gap-5 mb-14" data-id="element-79">
            {[{
            icon: <LeafIcon className="w-6 h-6" data-id="element-80" />,
            text: 'Neblina mental que ralentiza tus ideas'
          }, {
            icon: <DropletIcon className="w-6 h-6" data-id="element-81" />,
            text: 'Inflamación en el vientre que no se va'
          }, {
            icon: <MoonIcon className="w-6 h-6" data-id="element-82" />,
            text: 'Cansancio que se ha vuelto tu compañero constante'
          }].map((item, i) => <FadeIn key={i} delay={i * 100} data-id="element-83">
                <div className="p-7 rounded-2xl text-center h-full" style={{
              backgroundColor: 'var(--color-cream)',
              border: '2px solid var(--color-border)'
            }} data-id="element-84">
                  <div className="w-12 h-12 mx-auto mb-4 rounded-full flex items-center justify-center" style={{
                backgroundColor: 'rgba(143,175,138,0.15)',
                color: 'var(--color-sage)'
              }} data-id="element-85">
                    {item.icon}
                  </div>
                  <p className="text-base leading-relaxed" data-id="element-86">{item.text}</p>
                </div>
              </FadeIn>)}
          </div>
          <FadeIn data-id="element-87">
            <p className="text-xl md:text-2xl text-center" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 400
          }} data-id="element-88">
              Te han dicho que es normal. Te han dicho que "es la edad".
              <br data-id="element-89" />
              <strong style={{
              color: 'var(--color-terracotta)',
              fontWeight: 600
            }} data-id="element-90">
                Pero sabes dentro de ti que hay algo más.
              </strong>
            </p>
          </FadeIn>
        </div>
      </section>

      {/* ── ROOT CAUSE ── */}
      <section className="w-full px-6 py-10 md:py-16" data-id="element-91">
        <div className="max-w-3xl mx-auto" data-id="element-92">
          <FadeIn data-id="element-93">
            <h2 className="text-4xl md:text-5xl text-center mb-6" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500
          }} data-id="element-94">
              No es tu culpa.
              <br data-id="element-95" />
              <em style={{
              color: 'var(--color-sage)'
            }} data-id="element-96">
                Es tu biología.
              </em>
            </h2>
            <p className="text-lg leading-relaxed mb-4 text-center" style={{
            opacity: 0.8
          }} data-id="element-97">
              A partir de los 40, tu cuerpo entra en una nueva etapa hormonal.
              El cortisol sube, los estrógenos bajan y el metabolismo cambia.
              Las dietas de siempre y las rutinas agotadoras solo empeoran la
              situación.
            </p>
          </FadeIn>
          <div className="w-16 h-px mx-auto my-12" style={{
          backgroundColor: 'var(--color-border)'
        }} data-id="element-98" />
          <FadeIn data-id="element-99">
            <h3 className="text-2xl md:text-3xl text-center mb-8" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500
          }} data-id="element-100">
              Por qué lo que probaste falló
            </h3>
          </FadeIn>
          <div className="space-y-4 max-w-xl mx-auto" data-id="element-101">
            {[{
            myth: 'Comer menos',
            truth: 'Tu cuerpo lo interpreta como estrés y retiene más grasa.'
          }, {
            myth: 'Correr más',
            truth: 'Eleva aún más tu cortisol, empeorando el desequilibrio.'
          }, {
            myth: 'Dietas restrictivas',
            truth: 'Aumentan la inflamación y agotan tus reservas hormonales.'
          }].map((item, i) => <FadeIn key={i} delay={i * 80} data-id="element-102">
                <div className="flex items-start gap-4 p-5 rounded-2xl" style={{
              backgroundColor: 'var(--color-cream-dark)'
            }} data-id="element-103">
                  <div className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center" style={{
                backgroundColor: 'rgba(196,149,106,0.15)'
              }} data-id="element-104">
                    <XIcon className="w-4 h-4" style={{
                  color: 'var(--color-terracotta)'
                }} data-id="element-105" />
                  </div>
                  <div data-id="element-106">
                    <p className="font-semibold mb-1" style={{
                  textDecoration: 'line-through',
                  opacity: 0.5
                }} data-id="element-107">
                      {item.myth}
                    </p>
                    <p className="text-sm leading-relaxed" style={{
                  opacity: 0.8
                }} data-id="element-108">
                      {item.truth}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
          <FadeIn delay={100} data-id="element-109">
            <p className="text-2xl md:text-3xl text-center mt-12" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500,
            color: 'var(--color-sage)'
          }} data-id="element-110">
              Lo que necesitas es un reset biológico,
              <br data-id="element-111" />
              no una dieta más.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* ── SOLUTION ── */}
      <section className="w-full px-6 py-10 md:py-16" style={{
      backgroundColor: 'var(--color-cream-dark)'
    }} data-id="element-112">
        <div className="max-w-4xl mx-auto" data-id="element-113">
          <FadeIn data-id="element-114">
            <p className="text-xs tracking-[0.3em] uppercase text-center mb-3" style={{
            color: 'var(--color-terracotta)'
          }} data-id="element-115">
              La solución
            </p>
            <h2 className="text-4xl md:text-5xl text-center mb-3" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500
          }} data-id="element-116">
              Protocolo Reinicio Hormonal
            </h2>
            <p className="text-lg text-center italic mb-12" style={{
            fontFamily: 'var(--font-heading)',
            opacity: 0.7
          }} data-id="element-117">
              21 días · Nutrición anti-inflamatoria · Adaptógenos naturales
            </p>
          </FadeIn>
          <div className="grid md:grid-cols-2 gap-3 max-w-2xl mx-auto mb-12" data-id="element-118">
            {['Plan de alimentación anti-inflamatoria de 21 días', 'Guía de adaptógenos naturales (disponibles en tu supermercado)', 'Protocolo de descanso y gestión del cortisol', 'Lista de compras semanal lista para usar', 'Recetas simples, deliciosas y efectivas', 'Sin fármacos, sin productos caros, sin complicaciones'].map((item, i) => <FadeIn key={i} delay={i * 60} data-id="element-119">
                <div className="flex items-start gap-3 p-4 rounded-xl" style={{
              backgroundColor: 'var(--color-cream)'
            }} data-id="element-120">
                  <CheckIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                color: 'var(--color-sage)'
              }} data-id="element-121" />
                  <span className="text-sm leading-relaxed" data-id="element-122">{item}</span>
                </div>
              </FadeIn>)}
          </div>
          <FadeIn data-id="element-123">
            <div className="text-center" data-id="element-124">
              <img src="https://cdn.magicpatterns.com/uploads/5mLAKnpdhDAwp3mbDu76ac/heylloyd-image-1771522687649.png" alt="Protocolo Reinicio Hormonal" className="mx-auto w-44 md:w-52" style={{
              filter: 'drop-shadow(0 15px 35px rgba(0,0,0,0.12))'
            }} data-id="element-125" />
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── BONOS ── */}
      <section className="w-full px-6 py-10 md:py-16" style={{
      backgroundColor: 'var(--color-cream)'
    }} data-id="element-126">
        <div className="max-w-4xl mx-auto" data-id="element-127">
          {/* Headline */}
          <FadeIn data-id="element-128">
            <h2 className="text-4xl md:text-5xl text-center mb-6" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500
          }} data-id="element-129">
              Pero eso no es todo
              <br data-id="element-130" />
              <em style={{
              color: 'var(--color-sage)',
              fontStyle: 'italic'
            }} data-id="element-131">
                lo que recibes hoy.
              </em>
            </h2>
          </FadeIn>
          <FadeIn delay={80} data-id="element-132">
            <p className="text-lg text-center max-w-2xl mx-auto mb-14 leading-relaxed" style={{
            opacity: 0.75
          }} data-id="element-133">
              Cuando decides entrar al Protocolo Reinicio Hormonal, no solo
              recibes la guía principal. Hemos añadido{' '}
              <strong data-id="element-134">tres recursos extra</strong> para que no te quedes a
              medias — diseñados para eliminar cada excusa posible.{' '}
              <strong data-id="element-135">Y los tres son tuyos hoy. Gratis.</strong>
            </p>
          </FadeIn>

          {/* Bono cards */}
          <div className="space-y-8" data-id="element-136">
            {[{
            num: '1',
            badge: 'BONO GRATIS #1',
            value: 'Valorado en 21€ — Tuyo hoy: 0€',
            title: 'Recetario Hormonal Exprés',
            subtitle: '12 recetas antiinflamatorias listas en 15 minutos',
            img: 'https://cdn.magicpatterns.com/uploads/9CpFGzhYThEZ89SzXKuge4/imagen_bono1.png',
            intro: 'Si alguna vez has dicho "quiero comer mejor pero no sé por dónde empezar"... este bono es para ti. Recetas simples, con ingredientes de cualquier supermercado, listas en 15 minutos.',
            items: ['12 recetas antiinflamatorias con ingredientes del súper', 'Pasos en menos de 5 líneas + variaciones y sustituciones', 'Plan de 7 días con combinaciones simples', 'Lista de compra completa (versión "mínimos" incluida)', 'Checklist imprimible + Tracker semanal']
          }, {
            num: '2',
            badge: 'BONO GRATIS #2',
            value: 'Valorado en 21€ — Tuyo hoy: 0€',
            title: 'Calendario Reset de 7 Días',
            subtitle: 'Anti-ruido. Anti-culpa. Acción diaria.',
            img: 'https://cdn.magicpatterns.com/uploads/2Q5fgMEtaVWQzwGzg6Fhep/imagen_bono_2.png',
            intro: 'Saber qué hacer no es suficiente si cada mañana te levantas sin saber por dónde empezar. 7 días guiados, con solo 3 micro-acciones por día. Sin planes complicados. Sin perfección.',
            items: ['7 días guiados con 3 micro-acciones diarias', 'Trabaja comida, ritmo y calma cada día', 'Plan B completo para días caóticos', 'Tracker semanal de sueño, energía e hinchazón', 'Checklist imprimible + plantilla rellenable']
          }, {
            num: '3',
            badge: 'BONO GRATIS #3',
            value: 'Valorado en 21€ — Tuyo hoy: 0€',
            title: 'Reset de Estrés y Sueño: Protocolo 10 Min (AM/PM)',
            subtitle: 'Rutinas cortas para bajar el modo alerta y descansar mejor',
            img: 'https://cdn.magicpatterns.com/uploads/uwkME8eKwzEu9TeBX8uGN3/imagen_bono_3.png',
            intro: 'Si el cortisol elevado sabotea todo lo demás — el sueño, el metabolismo, los antojos — este bono te da dos rutinas de solo 10 minutos. Una para la mañana y otra para la noche.',
            items: ['Rutina AM de 10 min: señales de calma para empezar el día', 'Rutina PM de 10 min: señales de seguridad para descansar', 'Protocolos Express de 2 min (ansiedad, antojo, sobrecarga)', 'Scripts de auto-habla contra el autosabotaje', 'Tracker 7 días + checklist AM/PM imprimible']
          }].map((bono, i) => <FadeIn key={i} delay={i * 100} data-id="element-137">
                <div className="rounded-3xl overflow-hidden" style={{
              border: '1px solid var(--color-border)',
              backgroundColor: 'var(--color-cream-dark)'
            }} data-id="element-138">
                  <div className="flex flex-col md:flex-row" data-id="element-139">
                    {/* Image */}
                    <div className="md:w-56 flex-shrink-0 flex items-center justify-center p-6 md:p-8" style={{
                  backgroundColor: 'rgba(143,175,138,0.06)'
                }} data-id="element-140">
                      <img src={bono.img} alt={bono.title} className="w-36 md:w-44 rounded-xl" style={{
                    filter: 'drop-shadow(0 10px 25px rgba(0,0,0,0.15))'
                  }} data-id="element-141" />
                    </div>
                    {/* Content */}
                    <div className="flex-1 p-6 md:p-8" data-id="element-142">
                      <div className="flex flex-wrap items-center gap-3 mb-3" data-id="element-143">
                        <span className="text-xs font-semibold tracking-widest uppercase px-3 py-1 rounded-full" style={{
                      backgroundColor: 'var(--color-sage)',
                      color: '#fff'
                    }} data-id="element-144">
                          {bono.badge}
                        </span>
                        <span className="text-xs" style={{
                      opacity: 0.5,
                      textDecoration: 'line-through'
                    }} data-id="element-145">
                          {bono.value}
                        </span>
                      </div>
                      <h3 className="text-2xl md:text-3xl mb-1" style={{
                    fontFamily: 'var(--font-heading)',
                    fontWeight: 500
                  }} data-id="element-146">
                        {bono.title}
                      </h3>
                      <p className="text-sm italic mb-4" style={{
                    fontFamily: 'var(--font-heading)',
                    opacity: 0.6
                  }} data-id="element-147">
                        "{bono.subtitle}"
                      </p>
                      <p className="text-sm leading-relaxed mb-5" style={{
                    opacity: 0.75
                  }} data-id="element-148">
                        {bono.intro}
                      </p>
                      <ul className="space-y-2" data-id="element-149">
                        {bono.items.map((item, j) => <li key={j} className="flex items-start gap-2 text-sm" data-id="element-150">
                            <CheckIcon className="w-4 h-4 flex-shrink-0 mt-0.5" style={{
                        color: 'var(--color-sage)'
                      }} data-id="element-151" />
                            <span style={{
                        opacity: 0.8
                      }} data-id="element-152">
                              {item}
                            </span>
                          </li>)}
                      </ul>
                      <p className="text-sm font-semibold mt-5" style={{
                    color: 'var(--color-sage)'
                  }} data-id="element-153">
                        Valor real: 21€ —{' '}
                        <span style={{
                      color: 'var(--color-terracotta)'
                    }} data-id="element-154">
                          Tuyo hoy: GRATIS
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </FadeIn>)}
          </div>

          {/* Summary stack */}
          <FadeIn delay={100} data-id="element-155">
            <div className="mt-12 rounded-3xl overflow-hidden" style={{
            border: '2px solid var(--color-sage)'
          }} data-id="element-156">
              <div className="px-6 py-4 text-center" style={{
              backgroundColor: 'var(--color-sage)'
            }} data-id="element-157">
                <p className="text-white font-semibold tracking-wide text-sm uppercase" data-id="element-158">
                  Resumen de lo que recibes hoy
                </p>
              </div>
              <div style={{
              backgroundColor: 'var(--color-cream-dark)'
            }} data-id="element-159">
                {[{
                icon: '📘',
                label: 'Protocolo Reinicio Hormonal (guía principal)'
              }, {
                icon: '🎁',
                label: 'Bono #1 — Recetario Hormonal Exprés'
              }, {
                icon: '🎁',
                label: 'Bono #2 — Calendario Reset de 7 Días'
              }, {
                icon: '🎁',
                label: 'Bono #3 — Reset de Estrés y Sueño AM/PM'
              }].map((row, i) => <div key={i} className="flex items-center px-6 py-3" style={{
                borderBottom: i < 3 ? '1px solid var(--color-border)' : 'none'
              }} data-id="element-160">
                    <span className="text-sm flex items-center gap-2" data-id="element-161">
                      <span data-id="element-162">{row.icon}</span>
                      <span style={{
                    opacity: 0.8
                  }} data-id="element-163">
                        {row.label}
                      </span>
                    </span>
                  </div>)}
              </div>
            </div>
          </FadeIn>

          {/* Closing copy */}
          <FadeIn delay={80} data-id="element-164">
            <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-165">
              <p className="text-lg leading-relaxed mb-8" style={{
              opacity: 0.75
            }} data-id="element-166">
                Queremos que tengas todo lo que necesitas para que esta vez sea
                diferente.
              </p>
              <p className="text-2xl md:text-3xl mb-8" style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 500,
              color: 'var(--color-sage)'
            }} data-id="element-167">
                ¿Lista para empezar tu reinicio hoy?
              </p>
              <a href="#oferta" data-id="element-168">
                <button className="inline-flex items-center gap-3 px-10 py-5 text-lg font-medium text-white rounded-full" style={{
                backgroundColor: 'var(--color-terracotta)',
                boxShadow: '0 8px 30px rgba(196,149,106,0.4)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease'
              }} onMouseEnter={e => {
                ;
                (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.04)';
                (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 12px 40px rgba(196,149,106,0.5)';
              }} onMouseLeave={e => {
                ;
                (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)';
                (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 8px 30px rgba(196,149,106,0.4)';
              }} onClick={handleBuyClick} data-id="element-169">
                  Pulsa aquí y accede ahora{' '}
                  <ArrowRightIcon className="w-5 h-5" data-id="element-170" />
                </button>
              </a>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── SCIENCE / WHY NOW ── */}
      <section className="w-full px-6 py-10 md:py-14" data-id="element-171">
        <div className="max-w-4xl mx-auto" data-id="element-172">
          <FadeIn data-id="element-173">
            <p className="text-xs tracking-[0.3em] uppercase text-center mb-3" style={{
            color: 'var(--color-sage)'
          }} data-id="element-174">
              Respaldado por la ciencia
            </p>
            <h2 className="text-4xl md:text-5xl text-center mb-4" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500
          }} data-id="element-175">
              Por qué funciona ahora
            </h2>
            <p className="text-lg text-center max-w-2xl mx-auto mb-14" style={{
            opacity: 0.75
          }} data-id="element-176">
              La ciencia de la inflamación hormonal ha avanzado. Sabemos
              exactamente cómo usar alimentos y suplementos simples para
              equilibrar tu química interna.
            </p>
          </FadeIn>
          <div className="grid md:grid-cols-3 gap-5" data-id="element-177">
            {[{
            stat: '73%',
            label: 'de mujeres mayores de 40 sufren inflamación crónica de bajo grado sin saberlo'
          }, {
            stat: '28%',
            label: 'de reducción del cortisol documentada con el uso correcto de adaptógenos naturales'
          }, {
            stat: '21 días',
            label: 'es el tiempo mínimo para reprogramar hábitos metabólicos y ver cambios reales'
          }].map((item, i) => <FadeIn key={i} delay={i * 100} data-id="element-178">
                <div className="p-7 rounded-2xl text-center" style={{
              backgroundColor: 'var(--color-cream-dark)',
              border: '1px solid var(--color-border)'
            }} data-id="element-179">
                  <p className="text-4xl md:text-5xl mb-3" style={{
                fontFamily: 'var(--font-heading)',
                fontWeight: 600,
                color: 'var(--color-sage)'
              }} data-id="element-180">
                    {item.stat}
                  </p>
                  <p className="text-sm leading-relaxed" style={{
                opacity: 0.75
              }} data-id="element-181">
                    {item.label}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </section>

      {/* ── TESTIMONIOS ── */}
      <section className="w-full px-6 py-10 md:py-14" style={{
      backgroundColor: 'var(--color-cream)'
    }} data-id="element-182">
        <div className="max-w-4xl mx-auto" data-id="element-183">
          <FadeIn data-id="element-184">
            <p className="text-xs tracking-[0.3em] uppercase text-center mb-3" style={{
            color: 'var(--color-terracotta)'
          }} data-id="element-185">
              Experiencias reales
            </p>
            <h2 className="text-4xl md:text-5xl text-center mb-14" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500
          }} data-id="element-186">
              Lo que otras mujeres
              <br data-id="element-187" />
              <em style={{
              color: 'var(--color-sage)',
              fontStyle: 'italic'
            }} data-id="element-188">
                están logrando
              </em>
            </h2>
          </FadeIn>
          <div className="grid md:grid-cols-3 gap-5" data-id="element-189">
            {[{
            quote: 'Desde la primera semana sentí menos hinchazón y más energía. El Protocolo es una guía real para mi cuerpo.',
            name: 'Laura M.'
          }, {
            quote: 'Pensé que era la edad, pero resultó ser mi entorno químico. Ahora duermo mejor y mi mente está clara.',
            name: 'Elena R.'
          }, {
            quote: 'Sin dietas extremas ni suplementos caros. Todo con ingredientes que tengo en casa. Esto me ha devuelto la confianza.',
            name: 'Marta S.'
          }].map((t, i) => <FadeIn key={i} delay={i * 100} data-id="element-190">
                <div className="flex flex-col justify-between p-4 rounded-2xl" style={{
              backgroundColor: 'var(--color-cream-dark)',
              border: '1px solid var(--color-border)'
            }} data-id="element-191">
                  <p className="text-2xl leading-none mb-2" style={{
                fontFamily: 'var(--font-heading)',
                color: 'var(--color-sage)',
                opacity: 0.5
              }} data-id="element-192">
                    "
                  </p>
                  <p className="text-lg leading-snug flex-1 mb-4" style={{
                fontFamily: 'var(--font-heading)',
                fontStyle: 'italic',
                opacity: 0.85
              }} data-id="element-193">
                    {t.quote}
                  </p>
                  <div className="flex items-center gap-2" data-id="element-194">
                    <div className="w-6 h-6 rounded-full flex-shrink-0" style={{
                  backgroundColor: 'rgba(143,175,138,0.25)'
                }} data-id="element-195" />
                    <p className="text-sm font-semibold" style={{
                  opacity: 0.7
                }} data-id="element-196">
                      {t.name}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </section>

      {/* ── GARANTÍA ── */}
      <section className="w-full px-6 py-8 md:py-10" style={{
      backgroundColor: 'var(--color-cream-dark)'
    }} data-id="element-197">
        <div className="max-w-2xl mx-auto text-center" data-id="element-198">
          <FadeIn data-id="element-199">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-6" style={{
            backgroundColor: 'rgba(143,175,138,0.15)',
            border: '2px solid var(--color-sage)'
          }} data-id="element-200">
              <ShieldCheckIcon className="w-8 h-8" style={{
              color: 'var(--color-sage)'
            }} data-id="element-201" />
            </div>
            <p className="text-xs tracking-[0.3em] uppercase mb-3" style={{
            color: 'var(--color-sage)'
          }} data-id="element-202">
              Sin riesgos
            </p>
            <h2 className="text-4xl md:text-5xl mb-6" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500
          }} data-id="element-203">
              Garantía 100% Tranquilidad
            </h2>
            <p className="text-lg leading-relaxed" style={{
            fontFamily: 'var(--font-heading)',
            fontStyle: 'italic',
            opacity: 0.8
          }} data-id="element-204">
              Si en 21 días no sientes una diferencia positiva, te devolvemos tu
              dinero. Sin preguntas, sin complicaciones. Queremos que pruebes el
              Protocolo sin riesgos.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* ── FINAL OFFER ── */}
      <section id="oferta" className="w-full px-6 py-12 md:py-20" style={{
      backgroundColor: 'var(--color-cream)'
    }} data-id="element-205">
        <div className="max-w-sm mx-auto" data-id="element-206">
          <FadeIn data-id="element-207">
            <p className="text-sm tracking-[0.3em] uppercase mb-6 text-center" style={{
            color: 'var(--color-terracotta)'
          }} data-id="element-208">
              Inversión en tu bienestar
            </p>

            {/* What you're buying */}
            <div className="rounded-2xl p-5 mb-4" style={{
            border: '1px solid var(--color-border)',
            backgroundColor: 'var(--color-cream-dark)'
          }} data-id="element-209">
              <p className="font-semibold text-base mb-4 text-center" style={{
              fontFamily: 'var(--font-body)'
            }} data-id="element-210">
                Estás comprando:
              </p>
              <ul className="space-y-3" data-id="element-211">
                {['Plan de alimentación anti-inflamatoria de 21 días', 'Guía de adaptógenos naturales del súper', 'Protocolo de descanso y gestión del cortisol', 'Lista de compras semanal lista para usar'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm leading-snug" data-id="element-212">
                    <CheckIcon className="w-4 h-4 flex-shrink-0 mt-0.5" style={{
                  color: 'var(--color-sage)'
                }} data-id="element-213" />
                    <span style={{
                  opacity: 0.85
                }} data-id="element-214">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* Bonos box */}
            <div className="rounded-2xl p-5 mb-6" style={{
            backgroundColor: 'rgba(143,175,138,0.12)',
            border: '1px solid rgba(143,175,138,0.3)'
          }} data-id="element-215">
              <p className="font-semibold text-base mb-4 flex items-center justify-center gap-2" data-id="element-216">
                <span data-id="element-217"></span>
                <span data-id="element-218">
                  + 3 Bonos GRATIS{' '}
                  <span style={{
                  color: 'var(--color-terracotta)'
                }} data-id="element-219">
                    (Valor 63€)
                  </span>
                </span>
              </p>
              <div className="space-y-4" data-id="element-220">
                {[{
                img: 'https://cdn.magicpatterns.com/uploads/9CpFGzhYThEZ89SzXKuge4/imagen_bono1.png',
                title: 'Recetario Hormonal Exprés',
                sub: '12 recetas antiinflamatorias en 15 min',
                detail: '12 recetas antiinflamatorias con ingredientes del súper, listas en 15 minutos. Incluye plan de 7 días, lista de compra y checklist imprimible.'
              }, {
                img: 'https://cdn.magicpatterns.com/uploads/2Q5fgMEtaVWQzwGzg6Fhep/imagen_bono_2.png',
                title: 'Calendario Reset de 7 Días',
                sub: 'Plan de acción diario anti-ruido',
                detail: '7 días guiados con 3 micro-acciones diarias. Trabaja comida, ritmo y calma. Incluye plan B para días caóticos y tracker semanal.'
              }, {
                img: 'https://cdn.magicpatterns.com/uploads/uwkME8eKwzEu9TeBX8uGN3/imagen_bono_3.png',
                title: 'Reset de Estrés y Sueño AM/PM',
                sub: 'Rutinas de 10 min para bajar el cortisol',
                detail: 'Rutina AM y PM de 10 minutos para bajar el modo alerta. Incluye protocolos express de 2 min y tracker de 7 días.'
              }].map((bono, i) => <div key={i} className="flex items-start gap-3" data-id="element-221">
                    <img src={bono.img} alt={bono.title} className="w-14 h-14 rounded-xl object-cover flex-shrink-0" style={{
                  filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.12))'
                }} data-id="element-222" />
                    <div className="flex-1" data-id="element-223">
                      <p className="text-sm font-semibold leading-tight" data-id="element-224">
                        {bono.title}
                      </p>
                      <p className="text-xs mt-0.5" style={{
                    opacity: 0.6
                  }} data-id="element-225">
                        {bono.sub}
                      </p>
                      {/* Expanded detail */}
                      <div style={{
                    maxHeight: bonosExpanded ? '120px' : '0',
                    overflow: 'hidden',
                    transition: 'max-height 0.35s ease'
                  }} data-id="element-226">
                        <p className="text-xs mt-2 leading-relaxed" style={{
                      opacity: 0.75
                    }} data-id="element-227">
                          {bono.detail}
                        </p>
                      </div>
                    </div>
                  </div>)}
              </div>

              {/* Ver más toggle */}
              <button onClick={() => setBonosExpanded(!bonosExpanded)} className="w-full flex items-center justify-center gap-1.5 mt-4 pt-3 text-xs font-medium" style={{
              borderTop: '1px solid rgba(143,175,138,0.25)',
              color: 'var(--color-sage)',
              transition: 'opacity 0.2s ease'
            }} data-id="element-228">
                <span data-id="element-229">{bonosExpanded ? 'Ver menos' : 'Ver más'}</span>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{
                transform: bonosExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.25s ease'
              }} data-id="element-230">
                  <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-231" />
                </svg>
              </button>
            </div>

            {/* Price */}
            <div className="text-center mb-6" data-id="element-232">
              <div className="flex items-center justify-center gap-3 mb-1" data-id="element-233">
                <span className="text-xl" style={{
                textDecoration: 'line-through',
                opacity: 0.4,
                fontFamily: "'Inter', system-ui, sans-serif"
              }} data-id="element-234">
                  47€
                </span>
                <span className="text-xs font-bold px-2 py-1 rounded-md text-white" style={{
                backgroundColor: 'var(--color-terracotta)'
              }} data-id="element-235">
                  86% OFF
                </span>
              </div>
              <div className="flex items-baseline justify-center gap-2" data-id="element-236">
                <p className="text-7xl font-bold leading-none" style={{
                fontFamily: "'Inter', system-ui, sans-serif",
                fontWeight: 800,
                color: 'var(--color-terracotta)',
                letterSpacing: '-0.04em'
              }} data-id="element-237">
                  6,39€
                </p>
              </div>
              <p className="text-sm mt-2" style={{
              opacity: 0.5
            }} data-id="element-238">
                Pago único · Acceso inmediato
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={100} data-id="element-239">
            <button onClick={handleBuyClick} className="w-full inline-flex items-center justify-center gap-3 px-8 py-5 text-lg font-medium text-white rounded-full mb-4" style={{
            backgroundColor: 'var(--color-terracotta)',
            boxShadow: '0 8px 30px rgba(196,149,106,0.45)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease'
          }} onMouseEnter={e => {
            ;
            (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.03)';
            (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 14px 45px rgba(196,149,106,0.55)';
          }} onMouseLeave={e => {
            ;
            (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)';
            (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 8px 30px rgba(196,149,106,0.45)';
          }} data-id="element-240">
              Sí, quiero el Protocolo <ArrowRightIcon className="w-5 h-5" data-id="element-241" />
            </button>
            <div className="flex flex-wrap justify-center gap-4 text-xs" style={{
            opacity: 0.5
          }} data-id="element-242">
              <span className="flex items-center gap-1" data-id="element-243">
                <DownloadIcon className="w-3 h-3" data-id="element-244" /> Descarga inmediata en PDF
              </span>
              <span className="flex items-center gap-1" data-id="element-245">
                <ShieldCheckIcon className="w-3 h-3" data-id="element-246" /> Pago 100% seguro
              </span>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="w-full px-6 py-10 md:py-14" style={{
      backgroundColor: 'var(--color-cream-dark)'
    }} data-id="element-247">
        <div className="max-w-2xl mx-auto" data-id="element-248">
          <FadeIn data-id="element-249">
            <p className="text-xs tracking-[0.3em] uppercase text-center mb-3" style={{
            color: 'var(--color-terracotta)'
          }} data-id="element-250">
              Preguntas frecuentes
            </p>
            <h2 className="text-3xl md:text-4xl text-center mb-10" style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 500
          }} data-id="element-251">
              Resolvemos tus dudas
            </h2>
          </FadeIn>
          <FaqAccordion data-id="element-252" />
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="w-full px-6 py-8 text-center text-xs" style={{
      borderTop: '1px solid var(--color-border)'
    }} data-id="element-253">
        <p className="mb-3" style={{
        opacity: 0.45
      }} data-id="element-254">
          © 2026 Protocolo Reinicio Hormonal · Todos los derechos reservados
        </p>
        <p className="mb-3" style={{
        opacity: 0.4
      }} data-id="element-255">
          Esta guía es informativa y no constituye consejo médico. Los
          resultados pueden variar.
        </p>
        <div className="flex justify-center gap-6" data-id="element-256">
          <button onClick={() => setModal('privacy')} className="underline underline-offset-2 transition-opacity hover:opacity-100" style={{
          opacity: 0.5,
          fontFamily: 'var(--font-body)'
        }} data-id="element-257">
            Política de Privacidad
          </button>
          <button onClick={() => setModal('terms')} className="underline underline-offset-2 transition-opacity hover:opacity-100" style={{
          opacity: 0.5,
          fontFamily: 'var(--font-body)'
        }} data-id="element-258">
            Aviso Legal
          </button>
        </div>
      </footer>

      {modal && <LegalModal type={modal} onClose={() => setModal(null)} data-id="element-259" />}
    </main>;
}